module.exports = __webpack_public_path__ + "images/FUSA_icons/007-diamond-ring.eacbff8de86339bcb6436f346cb63945.svg";